module.exports = __webpack_public_path__ + "static/media/Data_insight_3-4.df8942fb.svg";